<div class="header header-container pl-3 w-100 shadow-sm">
  <div class="w-100">
    <app-navigation-component [smallNav]="smallNav" />
  </div>
</div>
